import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoFootprintShield16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path fillRule="evenodd" clipRule="evenodd" d="M7.78631 1.04582C7.91343 0.984726 8.06143 0.984726 8.18855 1.04582L14.7162 4.18312C14.8916 4.2674 14.996 4.44691 14.9713 4.6399C14.745 6.4096 13.3693 14.9998 7.98744 14.9998C2.60553 14.9998 1.22989 6.4096 1.00359 4.6399C0.978912 4.44691 1.08329 4.2674 1.25865 4.18312L7.78631 1.04582ZM10.4656 8.90723H9.33418C8.5528 8.90723 7.91948 9.54097 7.91948 10.3228V11.4551H5.93918V4.66078H10.4656V5.94589C10.2991 5.84933 10.1061 5.79311 9.89978 5.79311C9.27486 5.79311 8.7683 6.30019 8.7683 6.92562C8.7683 7.55095 9.27486 8.05794 9.89978 8.05794C10.1061 8.05794 10.2991 8.00172 10.4656 7.90516V8.90723Z" fill={iconColor} /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoFootprintShield16;